import { Controller } from "@hotwired/stimulus"
import { Collapse } from "bootstrap"

export default class extends Controller {
  static targets = ["checkbox", "continueBtn", "collapseIcon", "accordionContent"]

  connect() {
    this.updateContinueButton()
    this.addCheckboxListeners()
  }

  addCheckboxListeners() {
    this.checkboxTargets.forEach((checkbox, index) => {
      checkbox.addEventListener('change', () => {
        this.updateContinueButton()
        
        // If checkbox is checked, collapse the accordion if it's open
        if (checkbox.checked) {
          this.collapseAccordion(index)
        }
      })
    })
  }

  collapseAccordion(index) {
    const accordionContent = this.accordionContentTargets[index]
    if (accordionContent && accordionContent.classList.contains('show')) {
      const bsCollapse = new Collapse(accordionContent, { toggle: false })
      bsCollapse.hide()
    }
  }

  updateContinueButton() {
    const allEnabledAndChecked = this.checkboxTargets.every(checkbox => 
      !checkbox.disabled && checkbox.checked
    )
    this.continueBtnTarget.disabled = !allEnabledAndChecked
  }

  // Handle accordion show/hide events
  accordionShown(event) {
    const index = this.getIndexFromElement(event.target)
    this.rotateIcon(index, true)
  }

  accordionHidden(event) {
    const index = this.getIndexFromElement(event.target)
    this.rotateIcon(index, false)
  }

  rotateIcon(index, expanded) {
    const icon = this.collapseIconTargets[index]
    if (icon) {
      if (expanded) {
        icon.classList.add('expanded')
      } else {
        icon.classList.remove('expanded')
      }
    }
  }

  getIndexFromElement(element) {
    const id = element.id
    return parseInt(id.replace('agreement-content-', ''))
  }
} 